// extracted by mini-css-extract-plugin
export var askAiIcon = "_o9-j";
export var category = "_o9-9";
export var categoryHeader = "_o9-e";
export var container = "_o9-0";
export var group = "_o9-a";
export var groupItems = "_o9-f";
export var groupSeparator = "_o9-k";
export var loading = "_o9-1";
export var noResults = "_o9-3";
export var placeholder = "_o9-2";
export var resultContent = "_o9-5";
export var resultIcon = "_o9-c";
export var resultItem = "_o9-g";
export var resultMeta = "_o9-8";
export var resultSubtitle = "_o9-7";
export var resultSuffix = "_o9-i";
export var resultTitle = "_o9-6";
export var resultsList = "_o9-4";
export var searchGroup = "_o9-d";
export var selected = "_o9-h";
export var subgroup = "_o9-b";